var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyboardArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3398_77182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3398_77182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.1998 14.7008C7.01647 14.5174 6.9248 14.2841 6.9248 14.0008C6.9248 13.7174 7.01647 13.4841 7.1998 13.3008L11.7998 8.70078C11.8998 8.60078 12.0081 8.52995 12.1248 8.48828C12.2415 8.44661 12.3665 8.42578 12.4998 8.42578C12.6331 8.42578 12.7623 8.45078 12.8873 8.50078C13.0123 8.55078 13.1165 8.61745 13.1998 8.70078L17.7998 13.3008C17.9831 13.4841 18.0748 13.7174 18.0748 14.0008C18.0748 14.2841 17.9831 14.5174 17.7998 14.7008C17.6165 14.8841 17.3831 14.9758 17.0998 14.9758C16.8165 14.9758 16.5831 14.8841 16.3998 14.7008L12.4998 10.8008L8.5998 14.7008C8.41647 14.8841 8.18314 14.9758 7.8998 14.9758C7.61647 14.9758 7.38314 14.8841 7.1998 14.7008Z",
    fill: "#2EBF93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowUp);
export default __webpack_public_path__ + "static/media/keyboard_arrow_up.95c985134936bc28fae72c9d277b14ce.svg";
export { ForwardRef as ReactComponent };